"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { IListPrice } from "@/interfaces/list-price.interface";
import { listPriceService } from "@/services/list-price.service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

export type UseGetListPricesReturn = RequestsBaseReturn<PaginatedResponse<IListPrice> | null>;

export interface UseGetListPricesProps extends RequestPagination, GetRequestProps {
  filters: IFilter<IListPrice>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IListPrice>[]];

const useGetListPrices = ({
  pageNumber,
  pageSize,
  filters,
  isPaused = false,
}: UseGetListPricesProps): UseGetListPricesReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "title");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IListPrice>, Error, GetAllSwrParams>(
    [SWR_KEYS.getListPrices, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      listPriceService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
      isPaused: () => isPaused,
    }
  );

  return { data, isLoading, error };
};

export { useGetListPrices };
